import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { IAppSlide, IAppVideos } from 'src/app/interfaces/book-store';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { getYoutubeId } from 'src/app/services/mapping.service';

@Component({
  selector: 'app-add-app-video',
  templateUrl: './add-app-video.component.html',
  styleUrls: ['./add-app-video.component.scss']
})
export class AddAppVideoComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;

  TITLE = "Add new slide"

  form: FormGroup;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  ITEM: any;
  YOUTUBE_ID:any;

  constructor(
    public dialogRef: MatDialogRef<AddAppVideoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: BookstoreStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
  ) { }


  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  async ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required])],
      description: [null],
      youtube: [null, Validators.compose([Validators.required, this.youtubeControl.bind(this)])],
    })
    const { ITEM } = this.data;
    this.ITEM = ITEM;
    if (ITEM) {
      this.TITLE = "Edit slide";
      const { name, description,youtube } = ITEM;
      this.form.patchValue({
        name, description,youtube
      })
    }
  }
  
  youtubeControl(control: AbstractControl) {
    if (control) {
      const { value } = control;
      this.YOUTUBE_ID = value ? getYoutubeId(value) : null;
    }
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.form.disable();
      const { ITEM } = this.data;
      const { user } = this.auth;
      this.error = null;
      this.isCreate = true;
      const { name, description,youtube } = f;
      const registerStatus = STATUS_OBJECT.submitted;
      const youtubeId = getYoutubeId(youtube) || null;

      const item: IAppVideos = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ITEM ? ITEM.page_key : ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name}`.trim()),
        organizationRef: null,
        organizationKey: null,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: `${name}`.trim() || null,
        description: description || null,
        youtube: youtube,
        youtubeId:youtubeId
      }


      this.store.addNewItem(COLLECTION_NAME.APP_VIDEOS, item, (success, res) => {
        if (success) {
          this.store.fetchData(COLLECTION_NAME.APP_VIDEOS, registerStatus.key)
          this.snackBar.open("Video has been created successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (!isNew) {
          this.dialogRef.close('yes');
        }
      })
    }
  }
}
